import { authGet, authPost } from "../http_client.js";
import type { TournamentClaimResponseDto, TournamentPayloadDto } from "../dto/tournament.dto.js";

export function getTournament(): Promise<TournamentPayloadDto>
{
  return authGet<TournamentPayloadDto>( "api/player/me/tournament" );
}

export function claimTournamentProgress( instance: string, index: number ): Promise<TournamentClaimResponseDto>
{
  return authPost<TournamentClaimResponseDto>( `api/player/me/tournament/progress/${index}/claim`, { instance } );
}

export function claimTournamentGrandPrize( instance: string ): Promise<TournamentClaimResponseDto>
{
  return authPost<TournamentClaimResponseDto>( "api/player/me/tournament/grand-prize/claim", { instance } );
}

export function claimTournamentPlace( instance: string ): Promise<TournamentClaimResponseDto>
{
  return authPost<TournamentClaimResponseDto>( "api/player/me/tournament/place/claim", { instance } );
}

export function debugTournamentAddCrowns( crowns: number ): Promise<Record<string, unknown>>
{
  return authPost<Record<string, unknown>>( "api/player/me/tournament/debug/add-crowns", { crowns } );
}

export function debugTournamentFillRoom( count: number, crowns_min: number, crowns_max: number ): Promise<Record<string, unknown>>
{
  return authPost<Record<string, unknown>>( "api/player/me/tournament/debug/fill-room", { count, crowns_min, crowns_max } );
}

export function debugTournamentAdvanceBots( minutes: number ): Promise<Record<string, unknown>>
{
  return authPost<Record<string, unknown>>( "api/player/me/tournament/debug/advance-bots", { minutes } );
}

export function debugTournamentReset(): Promise<Record<string, unknown>>
{
  return authPost<Record<string, unknown>>( "api/player/me/tournament/debug/reset", {} );
}
